<div class="card">
  <app-account-search-bar
    [fiatAccounts]="fiatAccounts"
    [cryptoAccounts]="cryptoAccounts"
    (searchChange)="handlerChangeSearch($event)"
  ></app-account-search-bar>
  <div class="accounts" *ngIf="!resultSearch?.query.length || resultSearch?.fiatAccounts.length">
    <h3 *ngIf="!resultSearch?.query.length || resultSearch?.fiatAccounts.length" class="title">
      Cuentas en Pesos/Dólares
    </h3>
    <div class="list">
      <!-- CUENTAS FIAT -->
      <app-account-card
        *ngFor="let account of resultSearch?.fiatAccounts || fiatAccounts"
        [isFiat]="true"
        [account]="account"
        [coinCode]="account.coin"
        (delete)="deleteFiatAccount($event)"
      ></app-account-card>

      <!-- AGREGAR CUENTA -->
      <div *ngIf="!resultSearch?.query.length" (click)="addAccount(true)" class="add-account">
        <div class="circle">
          <img src="assets/icons/add-account.svg" />
        </div>
      </div>
    </div>
  </div>
  <div class="accounts" *ngIf="!resultSearch?.query.length || resultSearch?.cryptoAccounts.length">
    <h3 class="title">Cuentas en Crypto</h3>
    <div class="list">
      <!-- CUENTAS CRYPTO -->
      <app-account-card
        *ngFor="let account of resultSearch?.cryptoAccounts || cryptoAccounts"
        [isFiat]="false"
        [account]="account"
        [coinCode]="account.coin"
        (delete)="deleteCryptoAccount(account)"
      ></app-account-card>

      <!-- AGREGAR CUENTA -->
      <div *ngIf="!resultSearch?.query.length" (click)="addAccount(false)" class="add-account">
        <div class="circle">
          <img src="assets/icons/add-account.svg" />
        </div>
      </div>
    </div>
  </div>

  <div
    class="no-results-search"
    *ngIf="
      resultSearch?.query.length &&
      !resultSearch?.fiatAccounts.length &&
      !resultSearch?.cryptoAccounts.length
    "
  >
    No se han encontrado resultados
  </div>
</div>
